<template>
    <div class="pa-5 compact-form" v-if="activeShop">
        <div v-for="(item, index) in activeShop.contacts" :key="item.id">
            <v-row no-gutters>
                <v-col class="mt-2 row-title" cols="3">{{ "Name" | t }}</v-col>
                <v-col cols="6">
                    <v-text-field
                        :value="item.name"
                        @input="updateContactField($event, 'name', index)"
                        class="text-field-item mb-1"
                        hide-details
                        dense
                        outlined
                    />
                </v-col>
            </v-row>
            <v-row no-gutters>
                <v-col class="mt-2 row-title" cols="3">{{ "Phone" | t }}</v-col>
                <v-col cols="6">
                    <v-text-field
                        :value="item.phone"
                        @input="updateContactField($event, 'phone', index)"
                        class="text-field-item mb-1"
                        hide-details
                        dense
                        outlined
                    />
                </v-col>
            </v-row>
            <v-row no-gutters>
                <v-col class="mt-2 row-title" cols="3">{{ "Position" | t }}</v-col>
                <v-col cols="6">
                    <v-text-field
                        :value="item.position"
                        @input="updateContactField($event, 'position', index)"
                        class="text-field-item mb-1"
                        hide-details
                        dense
                        outlined
                    />
                </v-col>
            </v-row>
            <v-row no-gutters>
                <v-col class="mt-2 row-title" cols="3">{{ "Email" | t }}</v-col>
                <v-col cols="6">
                    <v-text-field
                        :value="item.email"
                        @input="updateContactField($event, 'email', index)"
                        class="text-field-item mb-1"
                        hide-details
                        dense
                        outlined
                    />
                </v-col>
            </v-row>
            <v-row no-gutters>
                <v-col class="mt-2 row-title" cols="3">{{ "Additional field" | t }}</v-col>
                <v-col cols="6">
                    <v-text-field
                        :value="item.additional_field"
                        @input="updateContactField($event, 'additional_field', index)"
                        class="text-field-item mb-1"
                        hide-details
                        dense
                        outlined
                    />
                </v-col>
            </v-row>
            <v-row no-gutters justify="end" class="mr-2">
                <v-btn dark color="bal-red" class="px-2" @click.stop="deleteContact(index)">
                    <v-icon>delete</v-icon>
                    {{ "Delete" | t }}
                </v-btn>
            </v-row>
            <v-divider class="my-2" />
        </div>
        <v-btn dark color="bal-red" class="px-2 ml-2" @click.stop="addNewContact" style="min-width: 0;">
            <v-icon>add</v-icon><span>{{ "Add new" | t }}</span>
        </v-btn>
    </div>
</template>

<script>
import { mapState } from "vuex";
import Store from "@/store";

export default {
    name: "contacts-info-edit-tab",
    computed: {
        ...mapState("ShopsAdminStore", ["activeShop"])
    },
    methods: {
        updateContactField(value, field, index) {
            Store.commit("ShopsAdminStore/updateActiveShopContactProperty", {
                prop: field,
                value: value,
                index: index
            });
        },
        updateImageField(e) {
            Store.commit("ShopsAdminStore/setImageFile", { value: e });
        },
        addNewContact() {
            Store.commit("ShopsAdminStore/addNewShopContact");
        },
        deleteContact(index) {
            if (confirm("Are you sure you want to delete this contact?")) {
                Store.commit("ShopsAdminStore/deleteShopContact", index);
            }
        }
    }
};
</script>

<style scoped>
.row-title {
    color: #888;
}
</style>
